import { useNavigate } from "react-router-dom";

import { Stack, Typography } from "@mui/material";

import { DataTable } from "@/common/components/table/DataTable";
import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";
import { systemSettingsPath } from "@/router/SystemSettingsRoutes";
import { useTranslation } from "@/translations";

import { useCounselorList } from "./hooks/useCounselorList";

function CounselorListInner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading, columns } = useCounselorList();

  return (
    <Stack spacing={1} sx={{ height: "100%" }} overflow={"hidden"}>
      {data.length === 0 && !isLoading ? (
        <Typography>{t("counselors.noResults")}</Typography>
      ) : (
        <Stack sx={{ overflow: "auto", flex: 1, minHeight: 0 }}>
          <DataTable
            data={data}
            columns={columns}
            isLoading={isLoading}
            getRowId={(row) => row.counselorId}
            onRowClick={(id) => void navigate(systemSettingsPath.byCounselorId({ id }))}
            initialSortModel={[{ field: "lastName", sort: "asc" }]}
          />
        </Stack>
      )}
    </Stack>
  );
}

export const CounselorList = withAuthorization(CounselorListInner, UserPermission.Supervisor);
